class PickerFollowingListFactory {
  constructor({ apiUrl, customerId }) {
    this.apiUrl = apiUrl
    this.customerId = customerId
    this.pickerFollowingListItemFactory = new PickerFollowingListItemFactory({
      apiUrl,
      customerId,
    })
    this.paginationFactory = new PickerFollowingListPaginationFactory("/pages/following")
    this.pickerFollow = new PickerFollow(apiUrl)
    this.pickerCollection = new PickerCollection()
    // this.storage = new PickerStorage()
    this.element = document.createElement('div')
    this.element.className = 'following-picker-list';
  }

  createEmptyElement() {
    const element = document.createElement('p')
    element.className = 'following-picker-list__empty'
    element.innerText = 'フォローしている出品者が見つかりませんでした。出品者ページからフォローが可能です。'
    return element
  }

  createErrorElement() {
    const element = document.createElement('p')
    element.className = 'following-picker-list__error'
    element.innerText = 'フォローしている出品者を取得できませんでした。'
    return element
  }

  

  async createElement() {
    // ローディング要素を作成
    const loadingElement = document.createElement('div')
    loadingElement.className = 'following-picker-list__loading'
    loadingElement.innerHTML = `<svg 
      xmlns="http://www.w3.org/2000/svg" 
      height="24px" 
      viewBox="0 -960 960 960" 
      width="24px" 
      fill="#03ffa8">
      <path d="M480-46q-90 0-168.97-34.08-78.97-34.07-137.92-93.03-58.96-58.95-93.03-137.92Q46-390 46-480q0-90.14 34.06-168.88 34.07-78.74 93-137.93Q232-846 311-880t169-34q26 0 44.5 18.5T543-851q0 26-18.5 44.5T480-788q-128.01 0-218.01 89.99-89.99 89.99-89.99 218T261.99-262q89.99 90 218 90T698-261.99q90-90 90-218.01 0-26 18.5-44.5T851-543q26 0 44.5 18.5T914-480q0 90-34.06 169.01-34.07 79.01-93 138Q728-114 649.14-80 570.28-46 480-46Z"/>
    </svg>`

    try {
      const containerElement = document.createElement('ul')
      const queryParams = new URLSearchParams(window.location.search)
      const page = queryParams.get('page') ?? 1

      this.element.appendChild(loadingElement)

      // はじめにローカルストレージに保存されたピッカーをフォロー連携
      await this.pickerFollow.syncPickers({ customerId: this.customerId })

      const {items, pagination} = await this.pickerFollow.getFollowingPickers({
        customerId: this.customerId,
        page
      })

      const listItems = await Promise.all(items.map(async (id) => {
        // const picker = this.storage.searchById(id)
        // if (!picker) {
        //   return null
        // }
        // PickerStorage無効化により、フォロー中ページは一時的に動作しません
        return null
        // const collection = await this.pickerCollection.searchCollection(picker.handle)
        // const products = await this.pickerCollection.searchCollectionProducts(picker.handle, 50)
        // return this.pickerFollowingListItemFactory.createElement({
        //   imageSrc: collection.image?.src ?? "",
        //   title: collection.title ?? "",
        //   productsCount: products.length ?? collection.products_count ?? 0,
        //   pickerId: collection.id ?? "",
        //   handle: collection.handle ?? "",
        //   isFollowing: true, // フォローリストの作成のため、初期値はフォロー中とする
        // })
      }))

      const availableListItems = listItems.filter(item => item !== null)

      // ローディング要素を削除
      this.element.removeChild(loadingElement)

      for (const listItem of availableListItems) {
        containerElement.appendChild(listItem)
      }

      if (availableListItems.length === 0) {
        this.element.appendChild(this.createEmptyElement())
      }

      containerElement.className = 'following-picker-list__container'
      this.element.appendChild(containerElement)

      if (pagination.totalPages && pagination.totalPages > 0) {
        this.element.appendChild(this.paginationFactory.createPagination(pagination.totalPages ?? 1, pagination.currentPage ?? 1))
      }

      return this.element
    } catch (error) {
      console.error(error)
       // ローディング要素を削除
      this.element.removeChild(loadingElement)
      this.element.appendChild(this.createErrorElement())
      return this.element
    }
  }

}
